import { render } from "./SidebarLayout.vue?vue&type=template&id=38f81b12&scoped=true"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"

import "./SidebarLayout.vue?vue&type=style&index=0&id=38f81b12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f81b12"]])

export default __exports__